module.exports = __webpack_public_path__ + "static/img/logo-white2.3103cd5.png";


//////////////////
// WEBPACK FOOTER
// ./~/wb-nav/logo-white2.png
// module id = 266
// module chunks = 2